import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Pageable, RestClientPaged } from '@elderbyte/ngx-starter'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { environment } from '../../../../environments/environment'
import { Delivery } from './delivery'
import { DeliveryFilterBuilder } from './delivery-filter-builder'

@Injectable({
  providedIn: 'root',
})
export class DeliveryService extends RestClientPaged<Delivery, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/deliveries', http, {
      idField: 'id',
    })
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public findAllOrderReference(number: string): Observable<Delivery[]> {
    return this.findAllPaged(new Pageable(0, 100), [
      DeliveryFilterBuilder.orderReferenceNumbers(number),
    ]).pipe(map((page) => page.content))
  }
}
